<div class="save-video-wrapper">
    @if (saving()) {
        <div class="mt-3">
            <kui-loader></kui-loader>
        </div>
    } @else {
        @if (errorMessage() || successMessage()) {
            <div>
                @if (errorMessage()) {
                    <div>{{ errorMessage() }}</div>
                }

                @if (successMessage()) {
                    <div>{{ successMessage() }}</div>
                }

                <div class="buttons">
                    <button kui-button (click)="close()" class="mr-1" color="primary">
                        {{ "DIALOG.CLOSE" | translate }}
                    </button>
                </div>
            </div>
        } @else {
            <div>
                <div>
                    <h5>{{ videoDetails().asset.name }}</h5>
                </div>

                <div>
                    {{ videoDetails().address }}
                </div>

                <div class="icon">
                    @if (isVideo()) {
                        <kui-icon class="mr-2" name="video" [size]="'xxl'" [color]="'primary'"></kui-icon>
                    } @else {
                        <kui-icon class="mr-2" name="image" [size]="'xxl'" [color]="'primary'"></kui-icon>
                    }
                </div>

                <div>
                    {{ videoDetails().date | date: "yyyy-MM-dd HH:mm:ss" }}
                </div>

                <div class="message">
                    {{ message() }}
                </div>

                @if (displayButtons()) {
                    <div class="buttons">
                        <button kui-button (click)="close()" class="mr-1" color="secondary">
                            {{ "VIDEOS.DETAILS.CANCEL" | translate }}
                        </button>

                        <button kui-button (click)="confirmSave()" class="mr-1" color="primary">
                            {{ "DIALOG.SAVE" | translate }}
                        </button>
                    </div>
                }
            </div>
        }
    }
</div>
